import React from 'react';
import AdminPanel from './Admin';

const AdminPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <AdminPanel />
    </div>
  );
};

export default AdminPage; 